/** Point and comment's shortcut and its switch (#717). */
import { useEffect, useState } from "react";
import { modKey } from "../../kit";

/** ⌘⇧F (Ctrl+Shift+F elsewhere), the classic tool's shortcut: it starts the picker from anywhere, over an open dialog too. */
export const isPickShortcut = (event: KeyboardEvent): boolean => event.code === "KeyF" && event.shiftKey && !event.altKey && event.metaKey !== event.ctrlKey;

/** The shortcut as Help lists it. */
export const PICK_KEYS = [modKey("").trim(), "Shift", "F"];

/** Whether the picker is on, and the shortcut that turns it on. */
export function usePick() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (!isPickShortcut(event)) return;
      event.preventDefault();
      setOpen(true);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return { open, start: () => setOpen(true), stop: () => setOpen(false) };
}
